import styled from "styled-components";
import PuffLoader from "react-spinners/PuffLoader";
import { useNavigate } from "react-router-dom";

const ErrorComponent = () => {
  const navigate = useNavigate();
  return (
    <Wrap>
      <PuffLoader color="#fa5963" />
      <div className="desc">
        <div>일시적인 오류가 발생했습니다.</div>
        {/* <div>
          <strong>엑세스 토큰 기간(30분)</strong>이 만료되었습니다.
        </div> */}
        <div>잠시 후 다시 시도해주세요.</div>
        <div className="desc-issue">
          지속적으로 문제가 발생하면 담당부서에 연락바랍니다.
        </div>
      </div>
      <button
        onClick={() => {
          navigate(-1);
          setTimeout(() => {
            window.location.reload();
          }, 100);
        }}
      >
        뒤로가기
      </button>
    </Wrap>
  );
};

export default ErrorComponent;
const Wrap = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .desc {
    font-size: 14px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .desc-issue {
      margin-top: 10px;
    }
  }
  button {
    margin-top: 20px;
    font-size: 14px;
    background-color: #fa5963;
  }
`;
